export enum Theme {
  BLACK = 'Black',
  BLUE = 'Blue',
  GREEN = 'Green',
  HEM_X = 'Hem X',
  RED = 'Red',
  YELLOW = 'Yellow',
  WHITE = 'White',
}

export enum Layout {
  CENTER = 'Center',
  LEFT = 'Left',
  MARQEE = 'Marqee',
  SPLIT = 'Split',
}
